
export function renderAiopsIntegration () {
    return (
  <div className="text-slate-900 dark:text-slate-100 transition-colors duration-300">

      <main className="py-10 transition-colors duration-300">
          {/* Breadcrumb */}
          <div className="flex items-center gap-2 text-xs text-slate-500 dark:text-slate-400 mb-6 font-mono">
            <span>Platform</span>
            <span className="material-symbols-outlined text-[10px]">chevron_right</span>
            <span>Netraa AI OPS</span>
            <span className="material-symbols-outlined text-[10px]">chevron_right</span>
            <span className="text-primary font-bold">Deep Ticket Enrichment</span>
          </div>

         {/* Hero Section */}
<section className="mb-16 relative group scroll-mt-24" id="ticket-hero">
  {/* Glow background */}
  <div className="absolute -inset-1 rounded-2xl opacity-20 transition duration-1000 group-hover:opacity-30 group-hover:duration-200" />

  {/* Card container */}
  <div className="relative rounded-2xl overflow-hidden transition-colors duration-300">
    <div className="grid gap-6 items-start relative z-10">
      
      {/* LEFT CONTENT (now full width) */}
      <div className="space-y-4 px-2">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#ff6a3d]/10 border border-[#ff6a3d]/30 text-[#ff6a3d] text-xs font-bold uppercase tracking-wider">
          <span className="animate-pulse size-2 rounded-full bg-[#ff6a3d]" />
          New Capability
        </div>

        {/* Heading */}
        <h1 className="text-5xl lg:text-4xl xl:text-5xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600 leading-tight font-display tracking-tight w-full">
          Deep Ticket Enrichment:
          <br />
          <span className="text-black dark:text-white">
            Transforming Alerts into{" "}Living Documents
          </span>
        </h1>

        {/* Description */}
        <p className="text-lg text-slate-700 dark:text-slate-300 leading-relaxed font-body transition-colors">
          Go beyond simple ticket creation. Netraa seamlessly integrates with Jira, OTRS, and Slack, enriching every incident with deep observability intelligence in real-time.
        </p>

        {/* CTA */}
        {/* <div className="pt-4">
          <button className="bg-gradient-to-r from-[#ff6a3d] to-[#ff3d2e] hover:opacity-90 text-white px-6 py-3 rounded-lg font-bold shadow-lg shadow-[#ff6a3d]/25 transition-all flex items-center gap-2">
            Explore Integration
            <span className="material-symbols-outlined text-lg">arrow_forward</span>
          </button>
        </div> */}
      </div>

      {/* RIGHT VISUAL (now full width, below CTA) */}
      <div className="relative h-96 w-full rounded-lg bg-[#080c14] border border-slate-200 dark:border-slate-800 flex items-center justify-center overflow-hidden transition-colors duration-300 group perspective-1000 mt-12">
        {/* Grid overlay */}
        <div className="absolute inset-0 opacity-10 dark:opacity-20 bg-[radial-gradient(#cbd5e1_1px,transparent_1px)] dark:bg-[radial-gradient(#334155_1px,transparent_1px)] [background-size:16px_16px]"></div>

        {/* 3D card */}
        <div className="
  relative w-64 h-80 bg-[#111827] rounded-lg shadow-2xl 
  border border-slate-200 dark:border-slate-700 
  p-4 flex flex-col gap-3 z-10

  rotate-y-12 rotate-x-6
  hover:rotate-y-0 hover:rotate-x-0
  transition-transform duration-700

  /* mobile fix ONLY */
  max-sm:rotate-0 max-sm:scale-90
">          <div className="flex justify-between items-center border-b border-slate-100 dark:border-slate-800 pb-2">
            <div className="flex items-center gap-2">
              <div className="size-3 rounded-full bg-red-500"></div>
              <div className="w-16 h-2 bg-slate-200 dark:bg-slate-700 rounded"></div>
            </div>
            <div className="w-8 h-2 bg-slate-200 dark:bg-slate-700 rounded"></div>
          </div>
          <div className="space-y-2">
            <div className="w-full h-2 bg-slate-100 dark:bg-slate-800 rounded"></div>
            <div className="w-3/4 h-2 bg-slate-100 dark:bg-slate-800 rounded"></div>
          </div>

          {/* Root Cause */}
          <div className="mt-4 p-3 rounded bg-orange-50 dark:bg-blue-900/20 border border-orange-100 dark:border-blue-800/30 hologram-pulse">
            <div className="text-[10px] text-orange-600 dark:text-blue-400 font-mono font-bold mb-1">ROOT CAUSE</div>
            <div className="w-full h-1.5 bg-orange-200 dark:bg-blue-700 rounded mb-1"></div>
            <div className="w-2/3 h-1.5 bg-orange-200 dark:bg-blue-700 rounded"></div>
          </div>

          {/* Remediation */}
          <div className="p-3 rounded bg-green-50 dark:bg-green-900/20 border border-green-100 dark:border-green-800/30 hologram-pulse" style={{ animationDelay: "1.5s" }}>
            <div className="text-[10px] text-green-600 dark:text-green-400 font-mono font-bold mb-1">REMEDIATION</div>
            <div className="w-full h-1.5 bg-green-200 dark:bg-green-700 rounded mb-1"></div>
            <div className="w-1/2 h-1.5 bg-green-200 dark:bg-green-700 rounded"></div>
          </div>
        </div>

        {/* Data Streams */}
        <svg className="absolute inset-0 pointer-events-none z-0" height="100%" width="100%">
          <path className="data-stream stroke-orange-300" d="M 20 50 Q 100 20 150 100" fill="none" strokeDasharray="10, 10" strokeWidth="2"></path>
          <path className="data-stream stroke-red-300" d="M 320 300 Q 250 350 200 250" fill="none" strokeDasharray="10, 10" strokeWidth="2" style={{ animationDirection: "reverse" }}></path>
          <path className="data-stream stroke-cyan-300" d="M 20 300 Q 100 350 150 200" fill="none" strokeDasharray="10, 10" strokeWidth="2"></path>
        </svg>

        {/* Live Sync Badge */}
        <div className="
  absolute 
  top-4 right-4 sm:top-10 sm:right-10 
  p-2 rounded-lg 
  bg-white/90 dark:bg-slate-800/80 
  backdrop-blur text-[10px] 
  text-slate-900 dark:text-white font-mono 
  border border-slate-300 dark:border-slate-700 
  shadow-lg z-20
">
        LIVE SYNC
        </div>
      </div>
    </div>
  </div>
</section>

            <section className="mb-20 grid lg:grid-cols-2 gap-12 items-center scroll-mt-24" id="manual-effort-gap">
              <div className="order-1 lg:order-1 space-y-6">
                <h2 className="text-3xl font-bold text-slate-900 dark:text-white font-display transition-colors">The Problem: <span className="text-secondary">Manual Effort &amp; Stale Context</span></h2>
                <div className="h-1 w-20 bg-gradient-netraa rounded-full"></div>
                <p className="text-slate-600 dark:text-slate-400 text-lg leading-relaxed transition-colors">Competitors create empty tickets with limited context. Engineers are forced to manually investigate, wasting time while collaboration suffers from static, outdated info.</p>
                <ul className="space-y-3 mt-4">
                  <li className="flex items-start gap-3 text-slate-700 dark:text-slate-300 transition-colors">
                    <span className="material-symbols-outlined text-secondary shrink-0 mt-0.5">timer</span>
                    <span>Hours lost piecing together fragmented logs.</span>
                  </li>
                  <li className="flex items-start gap-3 text-slate-700 dark:text-slate-300 transition-colors">
                    <span className="material-symbols-outlined text-secondary shrink-0 mt-0.5">sync_problem</span>
                    <span>Decisions made on 30-minute old data.</span>
                  </li>
                </ul>
              </div>
              <div className="order-2 lg:order-2">
                <div className="relative aspect-square max-h-[400px] rounded-xl bg-slate-50 dark:bg-[#10131a] border border-slate-200 dark:border-slate-800 p-8 flex items-center justify-center overflow-hidden group transition-colors duration-300 shadow-inner">
                  <div className="absolute inset-0 flex items-center justify-center opacity-5 dark:opacity-10 pointer-events-none">
                    <span className="material-symbols-outlined text-[300px] text-slate-900 dark:text-white">schedule</span>
                  </div>
                  <div className="relative w-64 bg-[#fdfbf7] dark:bg-[#e2e2e2] rounded shadow-xl border border-slate-300 p-6 transform rotate-2">
                    <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-4 h-4 rounded-full bg-slate-300 border border-slate-400"></div>
                    <div className="flex justify-between items-center mb-4 border-b border-slate-300 pb-2">
                      <div className="text-xs font-bold text-slate-800">INC-4091</div>
                      <div className="text-xs text-slate-500">2h ago</div>
                    </div>
                    <div className="space-y-4">
                      <div>
                        <div className="text-[10px] uppercase text-slate-400 font-bold mb-1">Description</div>
                        <div className="font-mono text-lg text-slate-800 font-bold">???</div>
                      </div>
                      <div>
                        <div className="text-[10px] uppercase text-slate-400 font-bold mb-1">Assigned To</div>
                        <div className="h-4 w-20 bg-slate-200 rounded animate-pulse"></div>
                      </div>
                    </div>
                    <div className="absolute -right-6 -bottom-6 bg-red-100 p-2 rounded-full border border-red-200 shadow-lg">
                      <span className="material-symbols-outlined text-red-600">sentiment_stressed</span>
                    </div>
                    <div className="absolute -left-6 -top-2 bg-orange-100 p-2 rounded-full border border-orange-200 shadow-lg">
                      <span className="material-symbols-outlined text-orange-600">warning</span>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="mb-3 scroll-mt-24" id="actionable-workflow">
              <div className="text-center mx-auto mb-12">
                <h2 className="text-3xl font-bold text-slate-900 dark:text-white mb-4 font-display transition-colors">The Solution: Actionable Intelligence &amp; Real-Time Sync</h2>
                <p className="text-slate-600 dark:text-slate-400 transition-colors">Tickets shouldn't be dead ends. Turn them into command centers.</p>
              </div>
              <div className="grid md:grid-cols-3 gap-6">
                <div className="glass-panel rounded-xl p-6 relative overflow-hidden group hover:border-primary/50 transition-all shadow-sm">
                  <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-400 to-blue-600"></div>
                  <div className="mb-6 flex justify-between items-start">
                    <div className="p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg text-blue-600 dark:text-blue-400">
                      <span className="material-symbols-outlined text-2xl">checklist</span>
                    </div>
                    <span className="text-sm font-bold text-slate-400 dark:text-slate-600 font-mono">STEP 01</span>
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-3 transition-colors">Comprehensive Enrichment</h3>
                  <p className="text-sm text-slate-600 dark:text-slate-400 mb-4 leading-relaxed transition-colors">Automatically populates Symptoms, Root Cause, and Impacted Components directly into the ticket fields.</p>
                </div>

                <div className="glass-panel rounded-xl p-6 relative overflow-hidden group hover:border-primary/50 transition-all shadow-sm">
                  <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-orange-400 to-red-500"></div>
                  <div className="mb-6 flex justify-between items-start">
                    <div className="p-3 bg-orange-50 dark:bg-orange-900/20 rounded-lg text-orange-600 dark:text-orange-400">
                      <span className="material-symbols-outlined text-2xl">build</span>
                    </div>
                    <span className="text-sm font-bold text-slate-400 dark:text-slate-600 font-mono">STEP 02</span>
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-3 transition-colors">Prescriptive Remediation</h3>
                  <p className="text-sm text-slate-600 dark:text-slate-400 mb-4 leading-relaxed transition-colors">AI-generated, step-by-step remediation plans so engineers start with the solution, not the problem.</p>
                </div>

                <div className="glass-panel rounded-xl p-6 relative overflow-hidden group hover:border-primary/50 transition-all shadow-sm">
                  <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-green-400 to-emerald-600"></div>
                  <div className="mb-6 flex justify-between items-start">
                    <div className="p-3 bg-green-50 dark:bg-green-900/20 rounded-lg text-green-600 dark:text-green-400 flex gap-2 items-center">
                      <span className="material-symbols-outlined text-2xl">sync</span>
                      <div className="flex -space-x-2 border-l border-green-200 dark:border-green-800 pl-2 ml-1">
                        <div className="size-4 bg-blue-500 rounded-full border border-white dark:border-slate-900"></div>
                        <div className="size-4 bg-purple-500 rounded-full border border-white dark:border-slate-900"></div>
                      </div>
                    </div>
                    <span className="text-sm font-bold text-slate-400 dark:text-slate-600 font-mono">STEP 03</span>
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-3 transition-colors">Continuous Live Updates</h3>
                  <p className="text-sm text-slate-600 dark:text-slate-400 mb-4 leading-relaxed transition-colors">Tickets act as living documents, continuously syncing via webhooks as system conditions change.</p>
                </div>
              </div>
            </section>

            <div className="mt-1 rounded-2xl bg-gradient-to-br from-[#121c2d] to-[#0a0f16] border border-slate-800 p-10 text-center relative overflow-hidden shadow-2xl">
              <div className="absolute top-0 right-0 p-12 opacity-10 pointer-events-none">
                <span className="material-symbols-outlined text-9xl text-white">auto_awesome</span>
              </div>
              <div className="absolute inset-0 bg-gradient-netraa opacity-5"></div>
              <h2 className="text-2xl font-bold text-white relative z-10 font-display">Stop creating tickets. Start resolving incidents.</h2>
              <p className="text-slate-400 max-w-lg mx-auto relative z-10">Automate context gathering and let your team focus on the fix.</p>
              {/* <button className="relative z-10 bg-white text-slate-900 hover:bg-slate-200 px-8 py-3 rounded-lg font-bold transition-all shadow-lg transform hover:-translate-y-0.5">Automate Your Workflow</button> */}
            </div>
        </main>
      </div>
  );
}